import React, { useState } from 'react';
import "./allpages.css";
import Header from '../../../layouts/doctor/DoctorHeader';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { Dragdrop } from './Dragdrop';
import { toast } from 'react-toastify';
import { Country } from "country-state-city";
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import dayjs from 'dayjs';

export const PipelineView = () => {

  const [value, setValue] = React.useState('1');
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [bvdqScore, setBvdqScore] = useState('');
  const [ country, setCountry ] = useState('');
  const [ search, setSearchValue ] = useState('');
  const [ birthday, setBirthDay ] = useState(null);

  const handleBVDQChange = (event) => {
    const value = event.target.value;
    // Ensure the value is less than or equal to 100
    if (value === '' || (Number(value) <= 100 && Number(value) >= 0)) {
      setBvdqScore(value);
    }else { 
      toast.error('Value must be between 0 and 100');
    }
  };

  const formatDate = (date) => {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [month, day, year].join('/');
  };


  const countries = Country.getAllCountries();

  const refreshPage = ()=>{
    setBvdqScore('');
    setCountry('');
    setBirthDay(null);
    setSearchValue('');
  }

  return (
    <div>
      <Header pageTitle="Leads" />
      <div className="cardOuter">
        <div className="cardheads">
          <div className="cardTitle">
            Pipeline View
          </div>
          <button className="btn blackoutlineBtn" onClick={refreshPage}>Refresh</button>
        </div>
        <div className="cardcontents">
          <div className="row firstcardcontent">
            <div className="col-lg-3 col-sm-12">
                <div className="formdesign">
                   <TextField
                      id="Search"
                      label="Search"
                      className="w-100"
                      variant="outlined"
                      size="small"
                      value={search}
                      onChange={(event) => setSearchValue(event.target.value)}
                    />
                </div>
            </div>
            <div className="col-lg-3 col-sm-12">
            <div className="formdesign">
              <FormControl fullWidth size="small">
                  <TextField
                      id="BVDQ"
                      label="BVDQ Score"
                      className="w-100"
                      variant="outlined"
                      size="small"
                      type='number'
                      value={bvdqScore}
                      onChange={handleBVDQChange}
                  />
              </FormControl>
              </div>
            </div>
            <div className="col-lg-3 col-sm-12">
            <div className="formdesign date-picker">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["DatePicker"]} >
                    <DatePicker
                      label="Date"
                      className="w-100"
                      variant="outlined"
                      size="small"
                      onChange={(date) => setBirthDay(date)}
                      value={birthday}
                      slotProps={{ textField: { size: 'small' } }}
                     
                      
                    />
                  </DemoContainer>
                </LocalizationProvider>
              </div>
            </div>
            <div className="col-lg-3 col-sm-12">
            <div className="formdesign">
                <FormControl fullWidth size="small">
                  <InputLabel id="country-label">Country</InputLabel>
                  <Select
                    labelId="country-label"
                    id="country"
                    onChange={(e) => {
                      const country = e.target.value;
                      setCountry(country);
                    }}
                    value={country}
                    label="Country"
                  >
                    <MenuItem value="">Select Country</MenuItem>
                    {countries.map((country) => (
                      <MenuItem key={country.isoCode} value={country.name}>
                        {country.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            </div>
          </div>
          <div className="newdragdrop">
            <Dragdrop bvdqScore={bvdqScore} country={country} birthday={formatDate(new Date(birthday))} search={search} />
          </div>
        </div>
      </div>
    </div>
  )
}
